import { useCallback } from 'react';

/**
 * Hook to detect if an element is inside an action sheet container
 * @returns A function that checks if a target element is inside an action sheet container
 */
export const useActionSheetDetection = () => {
  /**
   * Checks if the target element is inside an action sheet container
   * @param target The target element to check
   * @returns True if the target is inside an action sheet container, false otherwise
   */
  const isInsideActionSheet = useCallback((target: HTMLElement | null) => {
    if (!target) return false;
    return !!target.closest('.quill-ui-next-actionsheet-full-width');
  }, []);

  return { isInsideActionSheet };
};

export default useActionSheetDetection;